import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import ScenarioSelectionRedefinedDecisionContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedDecisionStepTemplate/Content';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride();

const ScenarioSelectionRedefinedDecisionStepTemplate = ({
  resource,
}) => {
  return (
    <MetaResourceRenderer
      layout={ScenarioSelectionRedefinedDecisionContent}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

ScenarioSelectionRedefinedDecisionStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedDecisionStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedDecisionStepTemplate;
